import { render, staticRenderFns } from "./CustomerMerging.vue?vue&type=template&id=33c9c152&"
import script from "./CustomerMerging.vue?vue&type=script&lang=js&"
export * from "./CustomerMerging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports